(() => {
  const DESKTOP_BP = 1024;
  const CLOSE_DELAY = 250;

  let closeTimer = null;
  let activeItem = null;
  let escapeBound = false;

  const isDesktop = () => window.innerWidth >= DESKTOP_BP;

  const getItems = () =>
    Array.from(document.querySelectorAll('#header .mega-menu__item[data-id]'));

  const getButtons = (item) =>
    Array.from(item.querySelectorAll('[data-element^="disclosure-button"]'));

  const getPanel = (item) => item.querySelector('.mega-menu__panel');

  const isOpen = (item) => {
    const panel = getPanel(item);
    return !!panel && !panel.hasAttribute('inert');
  };

  const isInsideMenuSystem = (node) => {
    if (!(node instanceof Node)) return false;
    return !!node.closest?.('#header .mega-menu__item[data-id], #header .mega-menu__panel');
  };

  const replayPanelAnimation = (panel) => {
    if (!panel) return;

    panel.classList.remove('mega-menu--animate-in');
    panel.querySelectorAll('.mega-menu__animate-item').forEach((el) => {
      el.style.animation = 'none';
      void el.offsetWidth;
      el.style.animation = '';
    });

    void panel.offsetWidth;
    panel.classList.add('mega-menu--animate-in');
  };

  const setPanelOpen = (item, open) => {
    const panel = getPanel(item);
    const buttons = getButtons(item);
    if (!panel) return;

    if (open) {
      panel.removeAttribute('inert');
      panel.classList.add('visible');
      buttons.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
      return;
    }

    panel.setAttribute('inert', '');
    panel.classList.remove('visible', 'mega-menu--animate-in');
    buttons.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
  };

  const handleEscape = (event) => {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    if (!isDesktop() || !activeItem) return;

    // Overliggende lag lukker sig selv: native <dialog> og kurv-draweren.
    if (document.querySelector('dialog[open]')) return;
    if (document.querySelector('#cart-dialog.translate-x-0')) return;

    const item = activeItem;

    event.preventDefault();
    clearTimeout(closeTimer);
    closeItem(item);
    getButtons(item)
      .find((btn) => btn.offsetParent !== null)
      ?.focus();
  };

  const bindEscape = (shouldBind) => {
    if (shouldBind === escapeBound) return;
    escapeBound = shouldBind;

    if (shouldBind) {
      document.addEventListener('keydown', handleEscape);
    } else {
      document.removeEventListener('keydown', handleEscape);
    }
  };

  const openItem = (item) => {
    if (!isDesktop() || !item) return;

    clearTimeout(closeTimer);

    if (activeItem === item && isOpen(item)) {
      return;
    }

    const panel = getPanel(item);
    const wasOpen = isOpen(item);

    setPanelOpen(item, true);

    if (!wasOpen) {
      replayPanelAnimation(panel);
    }

    getItems().forEach((other) => {
      if (other !== item && isOpen(other)) {
        setPanelOpen(other, false);
      }
    });

    activeItem = item;
    bindEscape(true);
  };

  const closeItem = (item) => {
    if (!item || !isDesktop()) return;

    setPanelOpen(item, false);

    if (activeItem === item) {
      activeItem = null;
      bindEscape(false);
    }
  };

  const scheduleClose = (item) => {
    clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => closeItem(item), CLOSE_DELAY);
  };

  const bindItem = (item) => {
    if (item.dataset.desktopHoverBound === 'true') return;
    item.dataset.desktopHoverBound = 'true';

    const panel = getPanel(item);

    item.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      openItem(item);
    });

    item.addEventListener('mouseleave', (event) => {
      if (!isDesktop()) return;
      if (isInsideMenuSystem(event.relatedTarget)) return;
      scheduleClose(item);
    });

    panel?.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      clearTimeout(closeTimer);
      activeItem = item;
    });

    panel?.addEventListener('mouseleave', (event) => {
      if (!isDesktop()) return;
      if (isInsideMenuSystem(event.relatedTarget)) return;
      scheduleClose(item);
    });

    getButtons(item).forEach((btn) => {
      btn.addEventListener('click', (event) => {
        if (!isDesktop() || !event.isTrusted) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (event.detail === 0) {
          if (isOpen(item)) closeItem(item);
          else openItem(item);
        }
      });
    });
  };

  const bindHeaderLeave = () => {
    const header = document.querySelector('#header.header--atc');
    if (!header || header.dataset.hoverLeaveBound === 'true') return;
    header.dataset.hoverLeaveBound = 'true';

    header.addEventListener('mouseleave', (event) => {
      if (!isDesktop()) return;
      if (isInsideMenuSystem(event.relatedTarget)) return;

      clearTimeout(closeTimer);

      if (activeItem) {
        scheduleClose(activeItem);
      }
    });
  };

  const init = () => {
    if (!document.querySelector('#header.header--atc')) return;

    getItems().forEach(bindItem);
    bindHeaderLeave();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', () => {
    if (!isDesktop()) {
      clearTimeout(closeTimer);
      activeItem = null;
      bindEscape(false);
    }
  });

  document.addEventListener('shopify:section:load', () => {
    window.setTimeout(init, 100);
  });
})();
